import { render, staticRenderFns } from "./DocContainer.vue?vue&type=template&id=32d81f56&scoped=true&"
import script from "./DocContainer.vue?vue&type=script&lang=js&"
export * from "./DocContainer.vue?vue&type=script&lang=js&"
import style0 from "./DocContainer.vue?vue&type=style&index=0&id=32d81f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d81f56",
  null
  
)

export default component.exports